const CUSTOM_PAY_SIM_OFFERS_PROVIDERS = {
    SIERRA_WIRELESS: {
        name: 'Sierra Wireless',
        key: 'SIERRA_WIRELESS',
        altKey: 'Sierra Wireless Ingenico',
        entities: {
            name: 'details.sim_offers.sierra_wireless.name',
            manage: 'details.sim_offers.sierra_wireless.manage'
        },
        offersEntities: [
            'modal.import.explanations.sierra_wireless.offers.ing_2',
            'modal.import.explanations.sierra_wireless.offers.ing_5',
            'modal.import.explanations.sierra_wireless.offers.ing_10',
            'modal.import.explanations.sierra_wireless.offers.ing_50',
            'modal.import.explanations.sierra_wireless.offers.ing_100'
        ]
    },
    DEUTSCHE_TELEKOM: {
        name: 'Deutsche Telekom',
        key: 'DEUTSCHE_TELEKOM',
        altKey: 'DEUTSCHE_TELEKOM',
        entities: {
            name: 'details.sim_offers.deutsche_telekom.name',
            manage: 'details.sim_offers.deutsche_telekom.manage'
        },
        offersEntities: [
            'modal.import.explanations.deutsche_telekom.offers.ing_5',
            'modal.import.explanations.deutsche_telekom.offers.ing_10',
            'modal.import.explanations.deutsche_telekom.offers.ing_20',
            'modal.import.explanations.deutsche_telekom.offers.ing_30',
            'modal.import.explanations.deutsche_telekom.offers.ing_50',
            'modal.import.explanations.deutsche_telekom.offers.ing_100',
            'modal.import.explanations.deutsche_telekom.offers.ing_100_zone_0124',
            'modal.import.explanations.deutsche_telekom.offers.ing_150',
            'modal.import.explanations.deutsche_telekom.offers.ing_150_zone_0124',
            'modal.import.explanations.deutsche_telekom.offers.ing_200',
            'modal.import.explanations.deutsche_telekom.offers.ing_200_zone_0124'
        ]
    }
};

export default CUSTOM_PAY_SIM_OFFERS_PROVIDERS;